export const ADD_DOCUMENT_FORM_NAME = 'ADD_DOCUMENT_FORM';
